<template>
  <span
    class="color-preview"
    :class="{ 'color-preview--colorful': colorful }"
    :style="containerStyle"
  >
  </span>
</template>

<script>
export default {
  name: 'color-preview',
  props: {
    code: String,
    colorful: Boolean,
  },
  computed: {
    containerStyle() {
      if (this.colorful) return undefined;
      return { backgroundColor: this.code };
    },
  },
};
</script>

<style scoped lang="scss">
.color-preview {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 50%;
  border: 1px solid #CCC;

  &--colorful {
    background: #006aff;
    background: -moz-linear-gradient(-45deg,  #006aff 0%, #55ff11 33%, #fff31e 66%, #ff0206 100%);
    background: -webkit-linear-gradient(-45deg,  #006aff 0%,#55ff11 33%,#fff31e 66%,#ff0206 100%);
    background: linear-gradient(135deg,  #006aff 0%,#55ff11 33%,#fff31e 66%,#ff0206 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#006aff', endColorstr='#ff0206',GradientType=1 );
  }
}
</style>



// WEBPACK FOOTER //
// ColorPreview.vue?763ff922